module.exports = __webpack_public_path__ + "static/media/as6cr0.b5ab97f9.png";